"use strict";
class Gameloop {
    constructor(main, fps) {
        /**
         * Performs the step routine.
         */
        this.step = () => {
            const startedAt = +new Date();
            this.main();
            const endedAt = +new Date();
            const wait = this.frame - (startedAt - endedAt);
            this.timer = setTimeout(this.step, wait);
        };
        this.main = main;
        this.frame = 1000 / fps;
    }
    /**
     * Starts the game loop.
     */
    run() {
        if (this.resolve) {
            return Promise.reject(new Error('The gameloop is already running.'));
        }
        return new Promise((resolve, _) => {
            this.resolve = resolve;
            this.step();
        });
    }
    /**
     * Returns true iff the loop is running.
     */
    isRunning() {
        return this.resolve != null;
    }
    /**
     * Stops the game loop.
     */
    stop() {
        if (!this.resolve) {
            console.warn('The gameloop isn\'t running.');
            return;
        }
        this.resolve();
        delete this.resolve;
        clearTimeout(this.timer);
    }
}
module.exports = (main, fps) => new Gameloop(main, fps);
